import { dataHooks } from '@wix/data-hooks';

export const templatesGridDataHooks = dataHooks<{
  templatesGrid: {};
  inspirationalTemplatesCarousel: {};
  marketplaceTemplatesCarousel: {};
}>('templates-grid');
